import { UiSettingsState } from "../state/ui-settings.state";
import { UiSettingsActions, UiSettingsActionType } from "../actions/ui-settings.action";

const initialState: UiSettingsState = {
  showTestData: false
};

export function uiSettingsReducer(state = initialState, action: UiSettingsActions): UiSettingsState {
  switch (action.type) {
    case UiSettingsActionType.TOGGLE_TEST_DATA:
      const newShowTestData = !state.showTestData;
      // Sync with session storage
      sessionStorage.setItem('showTestData', newShowTestData.toString());
      return {
        ...state,
        showTestData: newShowTestData
      };

    case UiSettingsActionType.SET_TEST_DATA:
      // Sync with session storage
      sessionStorage.setItem('showTestData', action.payload.toString());
      return {
        ...state,
        showTestData: action.payload
      };

    default:
      // Initialize from session storage on first load
      if (state === initialState && sessionStorage.getItem('showTestData') !== null) {
        return {
          ...state,
          showTestData: sessionStorage.getItem('showTestData') === 'true'
        };
      }
      return state;
  }
}
